export default function Customers() {
  return (
    <section className="sales-layout__page">
      <h1>Kunden</h1>
      <p>Wählen Sie einen Untermenüpunkt aus.</p>
    </section>
  );
}
